// import React, { useState } from "react";
// import "./Masterdata.css";

// const Getdata = () => {
//   const [formData, setFormData] = useState({
//     TableName: "",
//     WhereCondition: "",
//     Name: "",
//   });

//   const [responseData, setResponseData] = useState(null);
//   const [error, setError] = useState(null);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setResponseData(null);

//     console.log("🔵 Submitting Data:", formData);

//     const data = new URLSearchParams();
//     data.append("SecurityKey", "abcd");
//     data.append("TableName", formData.TableName || "");
//     data.append("WhereCondition", formData.WhereCondition || "");
//     data.append("Name", formData.Name || "");

//     console.log("Data being sent:", data.toString());

//     try {
//       const apiUrl = "http://etour.responseinfoway.com/restapi/Selectdata.aspx";
//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         body: data.toString(),
//       });
//       console.log(apiUrl)

//       console.log("Full Response:", response);

//       if (!response.ok) {
//         throw new Error(`HTTP Error! Status: ${response.status}`);
//       }

//       const responseText = await response.text();
//       console.log("Raw Server Response:", responseText);

//       try {
//         const jsonData = JSON.parse(responseText);
//         console.log("Parsed Response Data (JSON):", jsonData);

//         // Ensure responseData is an array for table rendering
//         if (Array.isArray(jsonData)) {
//           setResponseData(jsonData);
//         } else if (typeof jsonData === "object" && jsonData.data) {
//           setResponseData(Array.isArray(jsonData.data) ? jsonData.data : [jsonData.data]);
//         } else {
//           setResponseData([jsonData]); // Convert single object to array
//         }
//       } catch (error) {
//         console.warn("Response is not JSON. Displaying raw text.");
//         setResponseData([{ RawResponse: responseText }]); // Show raw text response inside the table
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setError("Failed to fetch data. Please try again.");
//     }
//   };

//   return (
//     <div className="masdata_container">
//       <form className="Columname-inputcolom" onSubmit={handleSubmit}>
//         <h5 className="fw-bold mb-2 m-auto">Master Data</h5>

//         <div className="input_text-labalname">
//           <label>Table Name</label>
//           <input
//             type="text"
//             name="TableName"
//             placeholder="Enter Table Name"
//             value={formData.TableName}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="input_text-labalname">
//           <label>Where Condition</label>
//           <input
//             type="text"
//             name="WhereCondition"
//             placeholder="Enter Where Condition"
//             value={formData.WhereCondition}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="input_text-labalname">
//           <label>Field Name</label>
//           <input
//             type="text"
//             name="Name"
//             placeholder="Enter Field Name"
//             value={formData.Name}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <button type="submit">Submit</button>
//       </form>

//       {error && <p className="error-message">{error}</p>}

//       {/* ✅ Table Rendering with Fix */}
//       {responseData && responseData.length > 0 ? (
//         <div className="response-container">
//           <table border="1">
//             <thead>
//               <tr>
//                 {Object.keys(responseData[0]).map((key) => (
//                   <th key={key}>{key}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {responseData.map((row, index) => (
//                 <tr key={index}>
//                   {Object.keys(row).map((key, i) => (
//                     <td key={i}>
//                       {typeof row[key] === "object" ? JSON.stringify(row[key]) : row[key]}
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : responseData ? (
//         <div className="response-container">
//           <h5>Raw Response Data:</h5>
//           <pre>{JSON.stringify(responseData, null, 2)}</pre>
//         </div>
//       ) : null}
//     </div>
//   );
// };

// export default Getdata;



import React, { useState } from "react";
import "./Masterdata.css";
import { SECURITY_KEY } from "../../globals";

const Getdata = () => {
  const [formData, setFormData] = useState({
    TableName: "",
    WhereCondition: "",
    Name: "",
  });

  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState(null);

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  // Use a proxy URL to bypass CORS if needed.
  // WARNING: Public proxies may have limits or SSL issues.
  // Change to "" (empty string) if your API allows CORS.
  // const proxyUrl = ""; // e.g. "https://cors-anywhere.herokuapp.com/";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResponseData(null);

    const data = new URLSearchParams();
    // data.append("SecurityKey", "abcd");
    data.append("SecurityKey", SECURITY_KEY);
    data.append("TableName", formData.TableName.trim());
    data.append("WhereCondition", formData.WhereCondition.trim());
    data.append("Name", formData.Name.trim());

    try {
      // const apiUrl = "https://etour.responseinfoway.com/restapi/Selectdata.aspx";
      // const apiUrl = "https://etourrestapi.responseinfoway.com/restApi/Selectdata.aspx";
      const apiUrl = `${BASE_REST_API_URL}/Selectdata.aspx`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });

      if (!response.ok) {
        throw new Error(`HTTP Error! Status: ${response.status}`);
      }

      const responseText = await response.text();

      try {
        const jsonData = JSON.parse(responseText);

        if (Array.isArray(jsonData)) {
          setResponseData(jsonData);
        } else if (typeof jsonData === "object" && jsonData.data) {
          setResponseData(Array.isArray(jsonData.data) ? jsonData.data : [jsonData.data]);
        } else {
          setResponseData([jsonData]);
        }
      } catch {
        // Not JSON, show raw text
        setResponseData([{ RawResponse: responseText }]);
      }
    } catch (error) {
      setError(`Failed to fetch data: ${error.message}`);
    }
  };

  return (
    <div className="masdata_container">
      <form className="Columname-inputcolom" onSubmit={handleSubmit}>
        <h5 className="fw-bold mb-2 m-auto">Master Data</h5>

        <div className="input_text-labalname">
          <label htmlFor="TableName">Table Name</label>
          <input
            type="text"
            id="TableName"
            name="TableName"
            placeholder="Enter Table Name"
            value={formData.TableName}
            onChange={handleChange}
            required
            autoComplete="off"
          />
        </div>

        <div className="input_text-labalname">
          <label htmlFor="WhereCondition">Where Condition</label>
          <input
            type="text"
            id="WhereCondition"
            name="WhereCondition"
            placeholder="Enter Where Condition"
            value={formData.WhereCondition}
            onChange={handleChange}
            required
            autoComplete="off"
          />
        </div>

        <div className="input_text-labalname">
          <label htmlFor="Name">Field Name</label>
          <input
            type="text"
            id="Name"
            name="Name"
            placeholder="Enter Field Name"
            value={formData.Name}
            onChange={handleChange}
            required
            autoComplete="off"
          />
        </div>

        <button type="submit">Submit</button>
      </form>

      {error && <p className="error-message">{error}</p>}

      {responseData && responseData.length > 0 ? (
        <div className="response-container">
          <table border="1" cellPadding="5" cellSpacing="0">
            <thead>
              <tr>
                {Object.keys(responseData[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {responseData.map((row, index) => (
                <tr key={index}>
                  {Object.keys(row).map((key, i) => (
                    <td key={i}>
                      {typeof row[key] === "object" ? JSON.stringify(row[key]) : row[key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : responseData ? (
        <div className="response-container">
          <h5>Raw Response Data:</h5>
          <pre>{JSON.stringify(responseData, null, 2)}</pre>
        </div>
      ) : null}
    </div>
  );
};

export default Getdata;
